import { Link } from "react-router-dom";

export const HomeIntro = () => {
  return (
    <section data-testid="home-intro" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-24">
        <div className="max-w-3xl">
          <h2
            data-testid="home-intro-title"
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#042D1F]"
          >
            Connecting Quality Indian Products with Global Markets
          </h2>
          <p data-testid="home-intro-paragraph-1" className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
            RKG NATURALS is an agricultural products importer, exporter and wholesaler focused on sourcing and
            supplying quality agricultural and natural products for domestic and international markets.
          </p>
          <p data-testid="home-intro-paragraph-2" className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Our focus is on quality sourcing, reliable supply, customer satisfaction and building long-term business
            relationships with buyers and trusted sourcing partners.
          </p>
          <Link
            to="/about-us"
            data-testid="home-intro-learn-more-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#0B4F37] text-[#0B4F37] font-semibold px-6 py-3 hover:bg-[#F2F9F5] transition-colors"
          >
            Learn More
          </Link>
        </div>
      </div>
    </section>
  );
};
